export default {
  name: 'Gallery section - 4',
  tab: 'gallery',
  type: 'slideshow-default-section',
  content: {
    title: 'Slideshow section',
    introtext: '',
    slides:
      '[{"slide-title":"Slide 1","slide-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","slide-image":"/storage/media/samples/chris-abney-qLW70Aoo8BE-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"slide-title":"Slide 2","slide-introtext":"<p>Donec ullamcorper nulla non metus auctor fringilla. Aenean lacinia bibendum nulla sed consectetur. Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur. Nullam quis risus eget urna mollis ornare vel eu leo.</p>","slide-image":"/storage/media/samples/erol-ahmed-_MYcIi9DgYQ-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"slide-title":"Slide 3","slide-introtext":"<p>Curabitur blandit tempus porttitor. Etiam porta sem malesuada magna mollis euismod. Nullam quis risus eget urna mollis ornare vel eu leo. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec ullamcorper nulla non metus auctor fringilla. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p>","slide-image":"/storage/media/samples/jeremy-thomas-Qw2CUd_9OWo-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'title-color': 'var(--accent-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'var(--accent-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'sm',
    'content-horizontal-alignment': 'start',
    'content-box': '1',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.75',
    'content-box-elevation': '0',
    'content-box-rounded': '1',
    'content-box-wrap': 'content',
    'content-box-border-color': 'var(--text-light-color)'
  },
  advanced: {}
}
